import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  Menu,
  MenuItem,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";

export const EGActionSheet = ({
  actions = [],
  renderTrigger,
  theme,
  textColor = "inherit",
  menuProps = {},
  drawerProps = {},
}) => {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const openMenu = (event) => {
    const trigger = event.currentTarget;
    if (isMobile) {
      setDrawerOpen(true);
    } else {
      setMenuAnchor(trigger);
    }
    trigger?.blur?.();
  };

  const closeMenu = () => {
    setMenuAnchor(null);
    setDrawerOpen(false);
  };

  const defaultAnchorOrigin = {
    vertical: "bottom",
    horizontal: "left",
  };
  const defaultTransformOrigin = {
    vertical: "top",
    horizontal: "right",
  };

  return (
    <>
      {/* Trigger */}
      {renderTrigger(openMenu)}

      {/* Menu Desktop */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={closeMenu}
        slotProps={{
          paper: {
            elevation: 3,
            sx: { minWidth: 230, py: 0, ...(menuProps.paperSx || {}) },
            ...(menuProps.PaperProps || {}),
          },
        }}
        anchorOrigin={menuProps.anchorOrigin ?? defaultAnchorOrigin}
        transformOrigin={menuProps.transformOrigin ?? defaultTransformOrigin}
        {...menuProps}
      >
        {actions.map((item, idx) => (
          <MenuItem
            key={idx}
            disabled={item.disabled}
            onClick={() => {
              closeMenu();
              item.onClick && item.onClick();
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              borderRadius: 3,
              m: 0.2,
            }}
          >
            {item.icon}
            <Typography color={item.textColor || textColor}>
              {item.name}
            </Typography>
          </MenuItem>
        ))}
      </Menu>

      {/* Drawer Mobile (Bottom Sheet) */}
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={closeMenu}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            pb: 2,
            ...(drawerProps.paperSx || {}),
          },
          ...(drawerProps.PaperProps || {}),
        }}
        {...drawerProps}
      >
        <Box sx={{ p: 2 }}>
          <Stack spacing={1}>
            {actions.map((item, idx) => (
              <Button
                key={idx}
                fullWidth
                variant="text"
                color={textColor}
                disabled={item.disabled}
                onClick={() => {
                  item.onClick && item.onClick();
                  closeMenu();
                }}
                sx={{
                  justifyContent: "flex-start",
                  textTransform: "none",
                  gap: 2,
                }}
                startIcon={item.icon}
              >
                {item.name}
              </Button>
            ))}
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};
